 <video
      #video
      autoplay
      playsinline
      muted
      [style.width.px]="width || null"
      [style.height.px]="height || null"
      style="max-width: 100%; background: #000; border-radius: 8px;"
    ></video>
    <canvas #canvas hidden></canvas>